import antdIR from "antd/lib/locale-provider/fa_IR";
import faMessages from "../locales/fa_IR.json";

const FaLang = {
  messages: {
    ...faMessages
  },
  antd: antdIR,
  locale: 'fa-IR',
};
export default FaLang;
